import "../Styles/index.scss";

document.querySelector(".header-nav-toggle")?.addEventListener("click", e => document.body.classList.toggle("is-nav-open"));

for (let element of document.querySelectorAll(".has-children .navigation__link.level-1")) {
	element.addEventListener("click", e => {
		let target = e.target as HTMLElement;
		let navItem = target.parentElement!;

		// toggle child container
		let container = navItem.querySelector(".navigation__container");
		container?.classList.toggle("is-open");

		// close all others
		for (let element of document.querySelectorAll(".navigation__container.is-open")) {
			if (element === container) {
				continue;
			}
			element.classList.remove("is-open");
		}

		e.preventDefault();
	});
}

// click outside menu to close
document.addEventListener("click", e => {
	let target = e.target as HTMLElement;
	if (!target.classList.contains("navigation__link") && target.closest(".navigation__container.is-open") == null) {
		document.querySelector(".navigation__container.is-open")?.classList.remove("is-open");
	}
});

import { Fancybox } from "@fancyapps/ui";
Fancybox.bind(".asset.is-zoomable", {
	// Your options go here
});

import Flickity from "flickity";
(window as any).flk = new Flickity(".header-slider", {
	autoPlay: 4000,
	wrapAround: true,
	prevNextButtons: false,
	setGallerySize: false,
});
